import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { usePermission } from 'admin/hocs'
import { useHasFeatureFunc } from 'utils/useHasFeature'
import { BaseRouteParams } from 'hocs'
import { parseSearch } from 'navigation'
import { UnderlineNavigationTabs } from 'uiComponents/navigation/underlineNavigationTabs'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'
import { useCapacityAccess } from 'capacity'
import { useTranslation } from 'translations'

function ProductSectionTabs() {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const location = useLocation()
    const history = useHistory()
    const { hasPermission } = usePermission()
    const hasFeature = useHasFeatureFunc()

    const viewMode = location.pathname.includes('flat') ? 'flat' : parseSearch(location.search).from || 'nested'
    const source = `?from=${viewMode}`
    const isPartnerAdmin = hasPermission('partner_admin', accountSlug)
    const capacityEnabled = useCapacityAccess(accountSlug)
    const inSection = (fragment: string) => location.pathname.includes(fragment)

    const tabs = [
        {
            name: t('products.sectionTabs.overview'),
            path: `/account/${accountSlug}/products/home/${viewMode}`,
            current: inSection('/products/home') || inSection('/products/productTable') || inSection('/products/crud'),
            shouldShow: true,
        },
        {
            name: 'Pricing exceptions',
            path: `/account/${accountSlug}/products/pricing/exceptions/list${source}`,
            current: inSection('/products/pricing/exceptions'),
            shouldShow: hasFeature('Pricing') && hasPermission('view_pricing_settings', accountSlug),
        },
        {
            name: 'Validity exceptions',
            path: `/account/${accountSlug}/products/validity/exceptions/list${source}`,
            current: inSection('/products/validity/exceptions'),
            shouldShow: hasPermission('view_product_validity', accountSlug),
        },
        {
            name: capacityEnabled ? 'Capacity' : 'Crowd Control',
            path: `/account/${accountSlug}/products/inventory/home${source}`,
            current: inSection('/products/inventory'),
            shouldShow: isPartnerAdmin,
        },
        {
            name: 'Time slots',
            path: `/account/${accountSlug}/products/time_slots/home${source}`,
            current: inSection('/products/time_slots'),
            shouldShow: isPartnerAdmin,
        },
        {
            name: 'Option groups',
            path: `/account/${accountSlug}/products/option_groups/home${source}`,
            current: inSection('/products/option_groups'),
            shouldShow: isPartnerAdmin,
        },
        {
            name: 'APF Studio',
            path: `/account/${accountSlug}/products/apf_studio/`,
            current: inSection('/products/apf_studio'),
            shouldShow: isPartnerAdmin,
        },
    ]
        .filter((tab) => tab.shouldShow)
        .map((tab) => ({
            name: tab.name,
            current: tab.current,
            href: tab.path,
            onClick: () => history.push(tab.path),
        }))

    if (tabs.length < 2) {
        return null
    }

    return (
        <InSectionTabsSlot>
            <UnderlineNavigationTabs tabs={tabs} />
        </InSectionTabsSlot>
    )
}

export default ProductSectionTabs
